var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 1.80904L8.184 0C7.80719 0.521154 6.97297 0.884837 6.00003 0.884837C5.02708 0.884837 4.19286 0.521154 3.81605 0L0.166099 1.80904C0.0180011 1.88403 -0.0419879 2.064 0.0311237 2.21209L1.10343 4.35857C1.17841 4.50667 1.35838 4.56666 1.50648 4.49355L2.56753 3.97427C2.76625 3.87679 2.9987 4.02114 2.9987 4.24422V8.99835C2.9987 9.33016 3.26678 9.59824 3.59859 9.59824H8.39771C8.72953 9.59824 8.9976 9.33016 8.9976 8.99835V4.24235C8.9976 4.02114 9.23006 3.87491 9.42877 3.97239L10.4898 4.49167C10.6379 4.56666 10.8179 4.50667 10.8929 4.3567L11.9671 2.21209C12.042 2.064 11.9821 1.88215 11.834 1.80904Z",
    fill: "#E8EAED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwags);
export default __webpack_public_path__ + "static/media/swags.e43a3b4fa675e7a6596847ef903ad731.svg";
export { ForwardRef as ReactComponent };